export default "__VITE_ASSET__BlejAI77__"